import "./header.scss";

// Fixed top shell shared by every page header. The in-flow spacer reserves
// the bar height so page content is never covered by the fixed header and
// no layout shift happens when navigating between pages.
function HeaderContainer({ children }) {
  return (
    <>
      <div className="Header-spacer" aria-hidden="true" />
      <header className="Header" dir="rtl">
        <div className="Header-inner">{children}</div>
      </header>
    </>
  );
}

export default HeaderContainer;
